<template lang="pug">
Popup(v-if="is_shown_popup", :isShowCloseButton="false")
  .user-transfer
    h2.user-transfer__title {{ $t('user_transfer.title') }}
    .user-transfer__text
      p(v-for="(text, text_id) in $t('user_transfer.text')", :key="text_id" v-html="text")

    .user-transfer__button
      MainButton(:isDisabled="isButtonDisabled", :label="$t('user_transfer.button')", @buttonClickEvent="acceptTransferTerms")

    .user-transfer__agreement
      p.user-transfer__agreement-text {{ $t('user_transfer.agreement.text') }}
      BaseCheckbox(id="agreement_transfer" v-model="agreement_transfer" :label="$t('user_transfer.agreement.transfer')")
      BaseCheckbox(id="agreement_legal" v-model="agreement_legal" :label="$t('user_transfer.agreement.legal')")

</template>

<script>
import { mapState, mapGetters } from "vuex";
import env from "@godweb/frontend-base/src/libs/tools/Environment";

import Popup from "../../popup/vue/Popup";
import MainButton from "../../main-button/vue/MainButton";
import BaseCheckbox from "../../form/vue/BaseCheckbox";

export default {
  name: "UserTransfer",

  components: {
    Popup,
    MainButton,
    BaseCheckbox,
  },

  data() {
    return {
      is_shown_popup: false,
      agreement_transfer: false,
      agreement_legal: false,
    };
  },

  computed: {
    ...mapGetters("global", ["isUserInProject", "isUserProcessed", "isSteamUser"]),
    ...mapState("global", ["user"]),

    isButtonDisabled() {
      return !this.agreement_transfer || !this.agreement_legal;
    },

    transferLink() {
      return `https://transfer.conquerorsblade.com/${env.getLang()}/?jump=mg`
    },
  },

  watch: {
    isUserProcessed: {
      handler() {
        if (this.isUserInProject && !this.isSteamUser && !this.user.fields.terms_accepted) {
          this.is_shown_popup = true;
        }
      },
      immediate: true,
    },
  },

  methods: {
    acceptTransferTerms() {
      return this.$api.userService
        .setTermsAccepted()
        .run()
        .then(response => {
          if (response.data.error) {
            console.error("Terms accept fail");
          } else {
            this.is_shown_popup = false;
            window.open(this.transferLink);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/user-transfer.scss";
</style>
